  import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const AxisHomeLoanEmiCalculator       = () => {
   const [loanAmount, setLoanAmount] = useState(5000000);
    const [interestRate, setInterestRate] = useState(7.5);
    const [loanTenure, setLoanTenure] = useState(20);
    const [monthlyEMI, setMonthlyEMI] = useState(0);
    const [totalInterest, setTotalInterest] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [amortizationSchedule, setAmortizationSchedule] = useState([]);
    const [activeYear, setActiveYear] = useState(null);
  
    const calculateEMI = () => {
      const principal = loanAmount;
      const annualInterest = interestRate / 100;
      const monthlyInterest = annualInterest / 12;
      const tenureInMonths = loanTenure * 12;
  
      const emi =
        (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
        (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);
  
      const totalAmount = emi * tenureInMonths;
      const totalInterest = totalAmount - principal;
  
      setMonthlyEMI(emi.toFixed(2));
      setTotalInterest(totalInterest.toFixed(2));
      setTotalAmount(totalAmount.toFixed(2));
  
      const schedule = [];
      let balance = principal;
      // let year = new Date().getFullYear();
      let currentYear = new Date().getFullYear();
  
      let currentMonth = 6;
  
      for (let i = 0; i < tenureInMonths; i++) {
        const interestForMonth = balance * monthlyInterest;
        const principalForMonth = emi - interestForMonth;
        balance -= principalForMonth;
  
        schedule.push({
          // month: i + 1,
          // year: year,
          month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
          year: currentYear + Math.floor((currentMonth + i) / 12),
          principalPaid: principalForMonth,
          interestPaid: interestForMonth,
          totalPayment: emi,
          balance: balance,
        });
  
        // if ((i + 1) % 12 === 0) {
        //   year++;
        // }
      }
  
      setAmortizationSchedule(schedule);
    };
  
    const handleLoanAmountChange = (e) => {
      const value = e.target.value;
      setLoanAmount(value === '' ? 0 : parseInt(value));
    };
  
    const handleInterestRateChange = (e) => {
      const value = e.target.value;
      setInterestRate(value === '' ? 0 : parseFloat(value));
    };
  
    const handleLoanTenureChange = (e) => {
      const value = e.target.value;
      setLoanTenure(value === '' ? 0 : parseInt(value));
    };
  
    const handleYearToggle = (year) => {
      setActiveYear(activeYear === year ? null : year);
    };
  
    const data = {
      labels: ['Principal Amount', 'Total Interest'],
      datasets: [
        {
          label: 'EMI Breakdown',
          data: [loanAmount, totalInterest],
          backgroundColor: ['#36A2EB', '#FF6384'],
        },
      ],
    };
    const categories = [
      { id: 1, name: 'Category 1', link: '/' },
      { id: 2, name: 'Category 2', link: '/' },
      { id: 3, name: 'Category 3', link: '/' },
      { id: 4, name: 'Category 4', link: '/' },
      // Add more categories as needed
    ];
  function Icon({ id, open }) {
      return (
          <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
          >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
          </svg>
      );
    }
    
    
      const [activeIndex, setActiveIndex] = useState(0);
    
       
      const faqs = [
        
  {
    "question": "What is the use of the Axis Bank Home Loan EMI Calculator?",
    "answer": "It helps you estimate your monthly EMIs and plan your loan repayment better."
  },
  {
    "question": "Is the EMI amount fixed for the entire loan tenure?",
    "answer": "Yes, in case of a fixed-rate loan. For floating-rate loans, it may vary."
  },
  {
    "question": "Can I use this calculator for a joint home loan?",
    "answer": "Yes, the tool can be used for any loan type; inputs remain the same."
  },
  {
    "question": "Does the calculator include processing fees?",
    "answer": "No, it only shows EMI. Processing fees must be added separately."
  },
  {
    "question": "How accurate is this calculator?",
    "answer": "It provides a close approximation based on standard formulas."
  },
  {
    "question": "Will prepayments affect my EMI?",
    "answer": "Yes, prepaying reduces your principal and may reduce EMI or tenure."
  },
  {
    "question": "Can I change my tenure after taking the loan?",
    "answer": "Yes, with Axis Bank’s approval, tenure can be adjusted."
  },
  {
    "question": "What’s the minimum loan tenure I can choose?",
    "answer": "Usually, Axis Bank offers a minimum of 5 years."
  },
  {
    "question": "Can the EMI amount be reduced over time?",
    "answer": "With part-payments or lower interest rates, yes."
  },
  {
    "question": "Does this calculator support floating interest rates?",
    "answer": "Yes, but results will vary over time as rates fluctuate."
  },
  {
    "question": "How can I reduce my total interest payment?",
    "answer": "Choose a shorter tenure, make prepayments, or negotiate better rates."
  },
  {
    "question": "What is the maximum home loan tenure Axis Bank offers?",
    "answer": "Up to 30 years, subject to eligibility and property type."
  },
  {
    "question": "Can I calculate EMI for under-construction properties?",
    "answer": "Yes, just enter the loan amount and expected tenure."
  },
  {
    "question": "Is the EMI auto-debited from my account?",
    "answer": "Yes, typically EMI is auto-debited from your Axis Bank account."
  },
  {
    "question": "Do I need to log in to use this calculator?",
    "answer": "No, it’s free and accessible without login on TheFinMaster."
  }
]
      const toggleAccordion = (index) => {
        if (activeIndex === index) {
            // If the clicked question is already expanded, collapse it
            setActiveIndex(null);
        } else {
            // If the clicked question is not expanded, expand it
            setActiveIndex(index);
        };
      }
    return (
      <>
  
  <Helmet>
           <title>Axis Bank Home Loan EMI Calculator – Plan Your Loan Smartly</title>
          <meta  name='description' content='Use the Axis Home Loan EMI Calculator to estimate monthly repayments. Manage your housing loan with clear financial planning.'/>
          <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/axis-home-loan-emi-calculator" />
          <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
          <meta name="robots" content="max-video-preview:-1" />
        </Helmet>
        <FAQSchema faqs={faqs} />
        {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
            <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </li>
          <li className="flex items-center">
            <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
            <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </li>
            <li className="flex items-center">
            <span className="text-gray-500 ">Axis Home Loan EMI Calculator</span>
          </li> 
        
        </ol>
      </nav> */}
          <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <div className='py-4 '>
  
     
      <div className="container mx-auto p-4 shadow-xl rounded-md ">
        <h1 className="text-2xl font-bold mb-4">Axis Home Loan EMI Calculator</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Loan Amount</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  value={loanAmount}
                  onChange={handleLoanAmountChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
              </div>
              <input
                type="range"
                min="0"
                max="100000000"
                value={loanAmount}
                onChange={(e) => setLoanAmount(parseInt(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  max="100"
                  step="0.1"
                  value={interestRate}
                  onChange={handleInterestRateChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">{interestRate} %</span>
              </div>
              <input
                type="range"
                min="0"
                max="15"
                step="0.1"
                value={interestRate}
                onChange={(e) => setInterestRate(parseFloat(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  max="30"
                  value={loanTenure}
                  onChange={handleLoanTenureChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">{loanTenure} Yr</span>
              </div>
              <input
                type="range"
                min="0"
                max="30"
                value={loanTenure}
                onChange={(e) => setLoanTenure(parseInt(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <button
              onClick={calculateEMI}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Calculate
            </button>
          </div>
          <div>
            <div className="mb-4">
              <h2 className="text-xl font-bold">Results</h2>
              <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
              <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
              <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
              <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
            </div>
            <div>
              <h2 className="text-xl font-bold">Breakdown</h2>
              <div className="flex justify-center">
                <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6">
          <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
          {amortizationSchedule.length > 0 && (
            <div className="flex flex-col space-y-4">
              {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
                <div key={idx} className="mb-4 border rounded-md shadow-md">
                  <div
                    className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                    onClick={() => handleYearToggle(year)}
                  >
                    <span>{year}</span>
                    <span>{activeYear === year ? '-' : '+'}</span>
                  </div>
                  {activeYear === year && (
                    <div className="overflow-x-auto">
                      <table className="min-w-full bg-white rounded-md shadow-md text-center">
                        <thead>
                          <tr>
                            <th className="py-2 px-4 border-b">Month</th>
                            <th className="py-2 px-4 border-b">Principal Paid</th>
                            <th className="py-2 px-4 border-b">Interest Charged</th>
                            <th className="py-2 px-4 border-b">Total Payment</th>
                            <th className="py-2 px-4 border-b">Balance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                            <tr key={idx}>
                              <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                              <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                              <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                              <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                              <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your Axis Bank Home Loan Payments with TheFinMaster’s EMI Calculator
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Looking to buy your dream home with the help of Axis Bank? Planning your EMI accurately can help you manage your finances better, avoid late payments, and optimize your budget. TheFinMaster’s Axis Bank Home Loan EMI Calculator is a powerful, user-friendly tool designed to give you detailed insights into your monthly EMIs, interest outgo, and overall repayment schedule. Whether you are buying your first house, investing in real estate, or refinancing an existing home loan, understanding your EMI structure is key to making smart, confident decisions.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Home Loan EMI?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Home Loan EMI (Equated Monthly Instalment) is the fixed payment you make each month to repay your home loan. It consists of two major components: the principal amount and the interest charged by the bank. While the EMI remains consistent throughout the loan tenure (in fixed-rate loans), the proportion of interest and principal changes over time. In the initial years, interest forms a major chunk of the EMI, and as the loan matures, the principal component increases.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For example, if you take a home loan of ₹50 lakhs at an interest rate of 8.5% per annum for a tenure of 20 years, your EMI would be approximately ₹43,391 per month.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is Axis Bank Home Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Axis Bank Home Loan EMI Calculator on TheFinMaster is a digital tool that calculates your expected monthly instalments based on the inputs you provide. It helps you assess affordability, compare loan scenarios, and plan finances without making manual calculations or using complicated formulas. Just enter your loan amount, interest rate, and tenure, and the calculator instantly displays your monthly EMI, total interest payable, and total repayment.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This calculator simplifies complex calculations, saves time, and provides clarity. It helps you avoid over-borrowing and ensures your EMI fits well within your monthly income and expenditure.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s Axis Bank Home Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Precision:</strong> Get accurate EMI estimates tailored to your inputs.</li>
                <li><strong>Ease of Use:</strong> No complicated formulas. Just input loan amount, tenure, and interest rate.</li>
                <li><strong>Time-Saving:</strong> Instant results help you plan faster.</li>
                <li><strong>Scenario Comparison:</strong> Adjust loan tenure or interest rates to compare different repayment strategies.</li>
                <li><strong>Financial Awareness:</strong> Know your financial obligation beforehand to plan a secure financial future.</li>
                <li><strong>Amortisation Table:</strong> Visualize how your loan is repaid over time.</li>
                <li><strong>Free & Unlimited Access:</strong> Use as many times as you like for multiple scenarios.</li>
              </ul>
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Axis Bank Home Loan EMI Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The calculator uses the following standard EMI formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P × R × (1+R)^N] / [(1+R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P is the loan amount</li>
              <li>R is the monthly interest rate (annual rate divided by 12 × 100)</li>
              <li>N is the loan tenure in months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong><br />
              If you take a loan of ₹40 lakhs from Axis Bank at an interest rate of 8.4% p.a. for a period of 25 years (300 months):<br />
              Loan Amount (P) = ₹40,00,000<br />
              Interest Rate (R) = 8.4% p.a. = 0.007 per month<br />
              Tenure (N) = 300 months<br />
              EMI = ₹31,788 (approximately)<br />
              Over the course of 25 years, you will repay ₹95,36,400, of which ₹55,36,400 is the interest amount.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortisation schedule is a detailed table showing the breakdown of each EMI over the tenure of your loan. It outlines how much of each EMI goes towards the principal and how much is paid as interest. Initially, a larger portion is paid as interest, while over time, the principal repayment increases.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>12-Month Amortisation Schedule (For ₹40 Lakhs at 8.4% for 25 Years)</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Outstanding (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">31,788</td>
                    <td className="border px-4 py-2">28,000</td>
                    <td className="border px-4 py-2">3,788</td>
                    <td className="border px-4 py-2">39,96,212</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">31,788</td>
                    <td className="border px-4 py-2">27,977</td>
                    <td className="border px-4 py-2">3,811</td>
                    <td className="border px-4 py-2">39,92,401</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">31,788</td>
                    <td className="border px-4 py-2">27,954</td>
                    <td className="border px-4 py-2">3,834</td>
                    <td className="border px-4 py-2">39,88,567</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">31,788</td>
                    <td className="border px-4 py-2">27,931</td>
                    <td className="border px-4 py-2">3,857</td>
                    <td className="border px-4 py-2">39,84,710</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">31,788</td>
                    <td className="border px-4 py-2">27,908</td>
                    <td className="border px-4 py-2">3,880</td>
                    <td className="border px-4 py-2">39,80,830</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">31,788</td>
                    <td className="border px-4 py-2">27,885</td>
                    <td className="border px-4 py-2">3,903</td>
                    <td className="border px-4 py-2">39,76,927</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">31,788</td>
                    <td className="border px-4 py-2">27,862</td>
                    <td className="border px-4 py-2">3,926</td>
                    <td className="border px-4 py-2">39,73,001</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">31,788</td>
                    <td className="border px-4 py-2">27,838</td>
                    <td className="border px-4 py-2">3,950</td>
                    <td className="border px-4 py-2">39,69,051</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">31,788</td>
                    <td className="border px-4 py-2">27,814</td>
                    <td className="border px-4 py-2">3,974</td>
                    <td className="border px-4 py-2">39,65,077</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">31,788</td>
                    <td className="border px-4 py-2">27,790</td>
                    <td className="border px-4 py-2">3,998</td>
                    <td className="border px-4 py-2">39,61,079</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">31,788</td>
                    <td className="border px-4 py-2">27,766</td>
                    <td className="border px-4 py-2">4,022</td>
                    <td className="border px-4 py-2">39,57,057</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">31,788</td>
                    <td className="border px-4 py-2">27,741</td>
                    <td className="border px-4 py-2">4,047</td>
                    <td className="border px-4 py-2">39,53,010</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI  (₹)</th>
          <th className="border px-4 py-2 text-left"> Interest   (₹)</th>
          <th className="border px-4 py-2 text-left">Principal(₹)</th>
          <th className="border px-4 py-2 text-left">Outstanding  (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
          ["1", "31,788", "28,000", "3,788", "39,96,212"],
          ["2", "31,788", "27,977", "3,811", "39,92,401"],
          ["3", "31,788", "27,954", "3,834", "39,88,567"],
          ["4", "31,788", "27,931", "3,857", "39,84,710"],
          ["5", "31,788", "27,908", "3,880", "39,80,830"],
          ["6", "31,788", "27,885", "3,903", "39,76,927"],
          ["7", "31,788", "27,862", "3,926", "39,73,001"],
          ["8", "31,788", "27,838", "3,950", "39,69,051"],
          ["9", "31,788", "27,814", "3,974", "39,65,077"],
          ["10", "31,788", "27,790", "3,998", "39,61,079"],
          ["11", "31,788", "27,766", "4,022", "39,57,057"],
          ["12", "31,788", "27,741", "4,047", "39,53,010"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
             ["1", "31,788", "28,000", "3,788", "39,96,212"],
             ["2", "31,788", "27,977", "3,811", "39,92,401"],
             ["3", "31,788", "27,954", "3,834", "39,88,567"],
             ["4", "31,788", "27,931", "3,857", "39,84,710"],
             ["5", "31,788", "27,908", "3,880", "39,80,830"],
             ["6", "31,788", "27,885", "3,903", "39,76,927"],
             ["7", "31,788", "27,862", "3,926", "39,73,001"],
             ["8", "31,788", "27,838", "3,950", "39,69,051"],
             ["9", "31,788", "27,814", "3,974", "39,65,077"],
             ["10", "31,788", "27,790", "3,998", "39,61,079"],
             ["11", "31,788", "27,766", "4,022", "39,57,057"],
             ["12", "31,788", "27,741", "4,047", "39,53,010"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI (₹):</span> {emi}</div>
        <div><span className="font-semibold">   Interest (₹):</span> {interest}</div>
        <div><span className="font-semibold">Principal(₹):</span> {principal}</div>
        <div><span className="font-semibold"> Outstanding  (₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Home Loan EMI
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ol className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Loan Amount:</strong> The total loan you borrow has a direct impact on your EMI. A higher principal loan amount will result in a proportionately larger EMI, especially if the interest rate and tenure remain unchanged.</li>
                <li><strong>Interest Rate:</strong> Even a slight variation in the interest rate—say 0.5%—can lead to a noticeable difference in your monthly EMI and total loan repayment. Choosing between fixed and floating rates also affects long-term EMI stability.</li>
                <li><strong>Loan Tenure:</strong> A longer repayment tenure reduces your monthly EMI burden, making it more affordable month-to-month. However, it increases the total interest outgo over the life of the loan, making the loan more expensive in the long run.</li>
                <li><strong>Processing Fees:</strong> Though it doesn’t directly influence your EMI amount, processing fees add to your upfront cost. It can slightly impact your initial budget and should be considered when calculating total cost of borrowing.</li>
                <li><strong>Prepayments:</strong> Making part-prepayments during the loan tenure helps in reducing the principal amount. This leads to a decrease in the remaining interest payable and future EMIs, or a shorter loan tenure, depending on lender terms.</li>
                <li><strong>Credit Score:</strong> A high credit/CIBIL score (usually 750+) shows financial discipline and increases your chances of securing a lower interest rate. A lower rate means reduced EMIs and overall loan cost.</li>
                <li><strong>Income & Profile:</strong> Lenders evaluate your income stability, job profile, and existing liabilities. A steady and high income with fewer liabilities can fetch you better interest rates and favorable terms, indirectly reducing your EMI burden.</li>
              </ol>
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>

                         {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default AxisHomeLoanEmiCalculator   ;
